import { faArrowRight as fasArrowRight } from "@awesome.me/kit-3777c2145e/icons/classic/solid";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import type { FormApi } from "final-form";
import type { ReactNode } from "react";
import { Card } from "react-bootstrap";
import { AbstractStep } from "@/component/assets/AbstractLeadForm/Steps/AbstractStep";
import { ButtonLegacy, FormDecidable } from "@/shared/ui";

export interface StepFields {
	hasAnotherCompanyUnderLiquidation: boolean;
	hasConnectedCompanyUnderLiquidation: boolean;
	ownerInKhr: boolean;
	ownerDenied: boolean;
	hadMoreThanHalfOwnerChange: boolean;
}

export class StepA3 extends AbstractStep<StepFields> {
	protected renderContent(_values: StepFields, form: FormApi<StepFields>): ReactNode {
		return (
			<>
				<Card.Body>
					<FormDecidable
						label="Van a tulajdonosi körben felszámolás alatt álló cég?"
						name="hasAnotherCompanyUnderLiquidation"
						required
					/>
					<FormDecidable
						label="Van a céged kapcsolt vállalkozásai között felszámolás alatt álló cég?"
						name="hasConnectedCompanyUnderLiquidation"
						required
					/>
					<FormDecidable
						label="Tulajdonosok/ügyvezetők/magánszemély készfizető kezesek szerepelnek a KHR/BAR listán?"
						name="ownerInKhr"
						required
					/>
					<FormDecidable
						label="Tulajdonosi és ügyvezető körben van cégvezetéstől eltiltott személy?"
						name="ownerDenied"
						required
					/>
					<FormDecidable
						label="Van 50%-nál nagyobb részben tulajdonos változás az elmúlt 6 hónapban?"
						name="hadMoreThanHalfOwnerChange"
						required
					/>
				</Card.Body>
				<Card.Footer className="text-center">
					<ButtonLegacy
						type="submit"
						icon={<FontAwesomeIcon icon={fasArrowRight} />}
						className={!form.getState().valid ? "disabled" : undefined}
					>
						Tovább
					</ButtonLegacy>
				</Card.Footer>
			</>
		);
	}

	protected getComponentName(): string {
		return "StepA3";
	}
}
